<div class="row">
  <div class="col">
    <table class="table table-sm z-depth-1" mdbTable mdbTableScroll 
      stickyHeader="true" scrollY="true" maxHeight="400" small="true" hover="true">
      <thead>
        <tr>
          <th *ngFor="let head of headElements; let i = index" scope="col">{{head}}</th>
        </tr>
      </thead>
      <tbody>
        <!-- Recorremos la lista de clientes -->
        <ng-container *ngFor="let c of listaClientes">
          <!-- Verificamos si tiene mensajes de error -->
          <ng-container *ngIf="c.mensajesErrors && c.mensajesErrors.length > 0">
            <!-- Iteramos sobre los mensajes de error -->
            <tr mdbTableCol *ngFor="let error of c.mensajesErrors; let first = first">
              <!-- Usamos [attr.rowspan] para manejar el rowspan dinámicamente -->
              <ng-container *ngIf="first">
                <th scope="row" [attr.rowspan]="c.mensajesErrors.length">{{ c.fila }}</th>
                <td [attr.rowspan]="c.mensajesErrors.length">{{ c.rutClienteFormateado | rut }}</td>
                <td [attr.rowspan]="c.mensajesErrors.length">{{ c.nombreCompletoCliente }}</td>
              </ng-container>
              <td class="text-danger font-weight-bolder">{{ error }}</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>